import { openBlock as r, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return r(), o("svg", l, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      d: "M14.71 15.88 10.83 12l3.88-3.88a.996.996 0 1 0-1.41-1.41L8.71 11.3a.996.996 0 0 0 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
